import { render, staticRenderFns } from "./UserSelfRegister.vue?vue&type=template&id=3f00838a&"
import script from "./UserSelfRegister.vue?vue&type=script&lang=ts&"
export * from "./UserSelfRegister.vue?vue&type=script&lang=ts&"
import style0 from "./UserSelfRegister.vue?vue&type=style&index=0&id=3f00838a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports